<template>
  <div class="full-height">
    <div
      :class="{
        simpleButtons: rowButtons,
        crudButtons: !rowButtons,
        cleanLayout: cleanLayout,
      }"
      class="row container q-px-sm"
    >
      <div class="fit">
        <crud-layout-search ref="crudLayoutSearch"  :name="name" :interface="nmInterface" :id="id" />
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import BillingOrderExportReport from '../report/BillingOrderExportReport.vue'
import { JtCrud } from 'jtech-webcomps'
const { CrudLayoutSearch } = JtCrud

@Component({
  name: 'BillingOrderReport',
  components: { CrudLayoutSearch, BillingOrderExportReport },
  props: {
    name: String,
    id: String
  }
})
class BillingOrderReport extends Vue {
  nmInterface = 'billingOrderReport.pesquisar'
}
export default BillingOrderReport
</script>
<style lang="stylus" scoped>

</style>
